import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { ClientConfigurationFormComponent } from '../client-configuration-form/client-configuration-form.component';
import {
  ClientConfigurationRequest,
  ClientConfigurationResponse,
} from '../../client.model';

@Component({
  selector: 'app-client-configuration-modal',
  imports: [MatDialogModule, ...SharedMaterialUIModule, ClientConfigurationFormComponent],
  templateUrl: './client-configuration-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientConfigurationModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ClientConfigurationModalComponent>);

  readonly clientId = input.required<string>();
  readonly initialValue = input<ClientConfigurationResponse | null>(null);
  readonly saving = input(false);

  protected onSubmit(request: ClientConfigurationRequest): void {
    this.dialogRef.close(request);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected get title(): string {
    return this.initialValue() ? 'Edit client configuration' : 'Create client configuration';
  }
}